module.exports = __webpack_public_path__ + "static/media/FactorySetup_white.285e444b.svg";